// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for src/pages/Merchants.jsx.
 * Loaded AFTER index.css (and after the page's own inline \\3c style>) so
 * equal-specificity rules here win by source order.
 *
 * Breakpoints (project standard):
 *   mobile  : <=576px
 *   tablet  : 577–991px
 *   laptop  : 992–1280px
 *   desktop : >=1281px
 *
 * DO NOT EDIT src/index.css. All overrides live here.
 */

/* The mobile card list is always hidden by default — shown only on mobile */
.merchants-page .merchant-card-list {
  display: none;
}

/* ===========================================================================
 * TABLET (<=991px): compact toolbar, 2-col stats, minor layout tweaks
 * ======================================================================== */
@media (max-width: 991px) {
  .merchants-page .table-toolbar {
    flex-wrap: wrap;
  }

  .merchants-page .search-box {
    max-width: 100%;
    flex: 1 1 220px;
  }

  /* Stats: 2 columns on tablet */
  .merchants-page .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ===========================================================================
 * MOBILE (<=576px): full single-column, app-like layout
 * ======================================================================== */
@media (max-width: 576px) {

  /* ---- Page wrapper ---- */
  .merchants-page {
    gap: 16px;
  }

  /* ---- Page header: stack title ---- */
  .merchants-page .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    margin-bottom: 0;
  }

  .merchants-page .page-header h1 {
    font-size: 22px;
  }

  /* ---- Stats grid: single column ---- */
  .merchants-page .stats-grid {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  /* Slightly compact stat cards on mobile */
  .merchants-page .stat-card {
    padding: 1rem;
    gap: 0.75rem;
  }

  .merchants-page .stat-icon {
    width: 40px;
    height: 40px;
  }

  .merchants-page .stat-value {
    font-size: 1.25rem;
  }

  /* ---- Status tabs: horizontal scroll ---- */
  .merchants-page .status-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding-bottom: 0;
  }

  .merchants-page .status-tabs::-webkit-scrollbar {
    display: none;
  }

  .merchants-page .status-tab {
    flex-shrink: 0;
    min-height: 44px;
    padding: 10px 14px;
  }

  /* ---- Toolbar: stack search above buttons ---- */
  .merchants-page .table-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .merchants-page .search-box {
    max-width: 100%;
    width: 100%;
    flex: unset;
  }

  .merchants-page .search-box input {
    width: 100%;
    min-height: 44px;
  }

  .merchants-page .toolbar-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .merchants-page .btn-toolbar,
  .merchants-page .btn-clear-filters {
    min-height: 44px;
    padding: 10px 12px;
  }

  /* Dropdown: prevent clipping off-screen */
  .merchants-page .dropdown-menu {
    left: 0;
    right: auto;
    min-width: calc(100vw - 32px);
    max-height: 60vh;
    overflow-y: auto;
  }

  /* ---- Table → cards ---- */

  /* Hide the desktop table */
  .merchants-page .merchants-table-container {
    overflow: visible;
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
  }

  .merchants-page .merchants-table {
    display: none;
  }

  /* Show the card list */
  .merchants-page .merchant-card-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* Each merchant row becomes a card */
  .merchants-page .merchant-row-card {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s;
    min-height: 44px;
  }

  .merchants-page .merchant-row-card:active {
    background: var(--bg-secondary);
  }

  /* Top row: name/email (left) + status badge (right) */
  .merchants-page .merchant-row-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 6px;
  }

  .merchants-page .merchant-row-card-top .merchant-details {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .merchants-page .merchant-row-card-top .merchant-name {
    font-weight: 600;
    font-size: 0.9rem;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .merchants-page .merchant-row-card-top .merchant-email {
    font-size: 0.78rem;
    color: var(--text-muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Business name row */
  .merchants-page .merchant-row-card-business {
    font-size: 0.8rem;
    color: var(--text-secondary);
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Bottom row: stats (left) + date (right) */
  .merchants-page .merchant-row-card-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .merchants-page .merchant-row-card-stat {
    font-size: 0.78rem;
    color: var(--text-secondary);
  }

  .merchants-page .merchant-row-card-date {
    font-size: 0.78rem;
    color: var(--text-muted);
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* Empty/loading states inside transparent container */
  .merchants-page .merchants-table-container .empty-state,
  .merchants-page .merchants-table-container .loading-container {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 10px;
  }

  /* ---- Pagination ---- */
  .merchants-page .pagination-container {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .merchants-page .pagination-info {
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px;
    font-size: 13px;
  }

  .merchants-page .page-size-select {
    min-height: 44px;
  }

  .merchants-page .pagination-controls {
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .merchants-page .pagination-btn,
  .merchants-page .page-number {
    min-width: 44px;
    min-height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Merchants.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF,4EAA4E;AAC5E;EACE,aAAa;AACf;;AAEA;;6EAE6E;AAC7E;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,qCAAqC;EACvC;AACF;;AAEA;;6EAE6E;AAC7E;;EAEE,2BAA2B;EAC3B;IACE,SAAS;EACX;;EAEA,uCAAuC;EACvC;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,kDAAkD;EAClD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,0CAA0C;EAC1C;IACE,OAAO;IACP,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,4BAA4B;;EAE5B,2BAA2B;EAC3B;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,qCAAqC;EACrC;IACE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;EACjC;;EAEA,sDAAsD;EACtD;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,sBAAsB;EACtB;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,4CAA4C;EAC5C;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;EAChB;;EAEA,sDAAsD;EACtD;;IAEE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Responsive overrides for src/pages/Merchants.jsx.\n * Loaded AFTER index.css (and after the page's own inline <style>) so\n * equal-specificity rules here win by source order.\n *\n * Breakpoints (project standard):\n *   mobile  : <=576px\n *   tablet  : 577–991px\n *   laptop  : 992–1280px\n *   desktop : >=1281px\n *\n * DO NOT EDIT src/index.css. All overrides live here.\n */\n\n/* The mobile card list is always hidden by default — shown only on mobile */\n.merchants-page .merchant-card-list {\n  display: none;\n}\n\n/* ===========================================================================\n * TABLET (<=991px): compact toolbar, 2-col stats, minor layout tweaks\n * ======================================================================== */\n@media (max-width: 991px) {\n  .merchants-page .table-toolbar {\n    flex-wrap: wrap;\n  }\n\n  .merchants-page .search-box {\n    max-width: 100%;\n    flex: 1 1 220px;\n  }\n\n  /* Stats: 2 columns on tablet */\n  .merchants-page .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ===========================================================================\n * MOBILE (<=576px): full single-column, app-like layout\n * ======================================================================== */\n@media (max-width: 576px) {\n\n  /* ---- Page wrapper ---- */\n  .merchants-page {\n    gap: 16px;\n  }\n\n  /* ---- Page header: stack title ---- */\n  .merchants-page .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n    margin-bottom: 0;\n  }\n\n  .merchants-page .page-header h1 {\n    font-size: 22px;\n  }\n\n  /* ---- Stats grid: single column ---- */\n  .merchants-page .stats-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n  }\n\n  /* Slightly compact stat cards on mobile */\n  .merchants-page .stat-card {\n    padding: 1rem;\n    gap: 0.75rem;\n  }\n\n  .merchants-page .stat-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .merchants-page .stat-value {\n    font-size: 1.25rem;\n  }\n\n  /* ---- Status tabs: horizontal scroll ---- */\n  .merchants-page .status-tabs {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    padding-bottom: 0;\n  }\n\n  .merchants-page .status-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .merchants-page .status-tab {\n    flex-shrink: 0;\n    min-height: 44px;\n    padding: 10px 14px;\n  }\n\n  /* ---- Toolbar: stack search above buttons ---- */\n  .merchants-page .table-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .merchants-page .search-box {\n    max-width: 100%;\n    width: 100%;\n    flex: unset;\n  }\n\n  .merchants-page .search-box input {\n    width: 100%;\n    min-height: 44px;\n  }\n\n  .merchants-page .toolbar-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .merchants-page .btn-toolbar,\n  .merchants-page .btn-clear-filters {\n    min-height: 44px;\n    padding: 10px 12px;\n  }\n\n  /* Dropdown: prevent clipping off-screen */\n  .merchants-page .dropdown-menu {\n    left: 0;\n    right: auto;\n    min-width: calc(100vw - 32px);\n    max-height: 60vh;\n    overflow-y: auto;\n  }\n\n  /* ---- Table → cards ---- */\n\n  /* Hide the desktop table */\n  .merchants-page .merchants-table-container {\n    overflow: visible;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n  }\n\n  .merchants-page .merchants-table {\n    display: none;\n  }\n\n  /* Show the card list */\n  .merchants-page .merchant-card-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  /* Each merchant row becomes a card */\n  .merchants-page .merchant-row-card {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    padding: 14px 16px;\n    cursor: pointer;\n    transition: background 0.15s;\n    min-height: 44px;\n  }\n\n  .merchants-page .merchant-row-card:active {\n    background: var(--bg-secondary);\n  }\n\n  /* Top row: name/email (left) + status badge (right) */\n  .merchants-page .merchant-row-card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 10px;\n    margin-bottom: 6px;\n  }\n\n  .merchants-page .merchant-row-card-top .merchant-details {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .merchants-page .merchant-row-card-top .merchant-name {\n    font-weight: 600;\n    font-size: 0.9rem;\n    color: var(--text-primary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .merchants-page .merchant-row-card-top .merchant-email {\n    font-size: 0.78rem;\n    color: var(--text-muted);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  /* Business name row */\n  .merchants-page .merchant-row-card-business {\n    font-size: 0.8rem;\n    color: var(--text-secondary);\n    margin-bottom: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  /* Bottom row: stats (left) + date (right) */\n  .merchants-page .merchant-row-card-bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .merchants-page .merchant-row-card-stat {\n    font-size: 0.78rem;\n    color: var(--text-secondary);\n  }\n\n  .merchants-page .merchant-row-card-date {\n    font-size: 0.78rem;\n    color: var(--text-muted);\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  /* Empty/loading states inside transparent container */\n  .merchants-page .merchants-table-container .empty-state,\n  .merchants-page .merchants-table-container .loading-container {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n  }\n\n  /* ---- Pagination ---- */\n  .merchants-page .pagination-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .merchants-page .pagination-info {\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 8px;\n    font-size: 13px;\n  }\n\n  .merchants-page .page-size-select {\n    min-height: 44px;\n  }\n\n  .merchants-page .pagination-controls {\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n\n  .merchants-page .pagination-btn,\n  .merchants-page .page-number {\n    min-width: 44px;\n    min-height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
